
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Zap } from 'lucide-react';

interface CardFooterProps {
  riskLevel: string;
  onPolicyExecute: (e: React.MouseEvent, policyId?: number) => void;
}

const CardFooter = ({ riskLevel, onPolicyExecute }: CardFooterProps) => {
  return (
    <div className="flex justify-between">
      <Badge className="bg-blue-900 text-blue-100 hover:bg-blue-800">{riskLevel}</Badge>
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={(e) => onPolicyExecute(e)}
              className="text-amber-500 hover:text-amber-400 hover:bg-gray-700/50"
            >
              <Zap className="h-4 w-4 mr-1" />
              Policies
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Run policy executor on this team</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default CardFooter;
